<template>
  <div
    :class="{
      'form-input': true,
      'form-input--required': data.required,
    }"
  >
    <div class="v-center space-between">
      <label>{{ data.caption }}:
        <img
      v-if="data.visibility"
      class="mx-1"
      width="15"
      src="~@/assets/images/eye.svg"
      alt="view"
      />
      </label>
      <button class="btn" v-if="!areActionsDisabled && mode !== 'VIEW'" @click="openMaterialModal">
        Add Material
      </button>
    </div>
    <div class="form-input--material">
      <!-- Add no material condition -->
      <div
        v-if="!componentValue.length"
        class="form-input--material__no-material"
      >
        No Material Selected Yet!
      </div>
      <div
        v-else-if="loadingSelectedMaterials"
        class="form-input--material__no-material"
      >
        <loading-circle />
      </div>
      <div v-else class="material-table dtx-table">
        <div class="bom-detail-table bom-detail-head bom-detail-header"
        :class="{'has-material': disableAction}" >
    <div>Product Code</div>
    <div>Material ID</div>
    <div>Quantity</div>
    <div>BOM</div>
    <div v-overflow-tooltip v-if="disableAction">Priority</div>
    <div></div>
    <!-- Only show empty header column if actions are allowed -->
    <div v-if="!areActionsDisabled"></div>
  </div>
  <div v-for="(item, index) in componentValue" :key="index">
        <div
          class="bom-detail-table bom-detail-body"
          :class="{ 'has-material': disableAction }"
        >
          <div  v-overflow-tooltip>
          {{ selectedMaterialsMap[item.material_id]?.material_product_code?.product_code || "--" }}
          </div>
          <div v-overflow-tooltip>{{ selectedMaterialsMap[item.material_id]?.material_name || "--" }}</div>
          <div><input
                  :disabled="areActionsDisabled"
                  type="number"
                  :min="1"
                  v-model="componentValue[index].quantity"
                  @change="handleQuantityChange(index)"
                /></div>
          <div>
            <div v-if="!bomAssociations[item.material_id]">
                  <img
                  v-if="selectedMaterialsMap[item.material_id]?.product_code && !isExternalCollaborator"
                    :class="{
                      'add-bom': true,
                      active: !areActionsDisabled,
                      'ml-2': true
                    }"
                    v-tooltip="'Associate Bom'"
                    src="~@/assets/images/icons/add-new-icon.svg"
                    width="20px"
                    alt=""
                    @click="!areActionsDisabled && openAssociateBomModal(item, index)"
                  />
                  <img
                    v-else
                    :class="{
                      'add-bom': true,
                      active: false,
                      'ml-2': true,
                    }"
                    src="~@/assets/images/icons/add-new-icon.svg"
                    width="20px"
                    alt=""
                  />
                </div>
                <div
                  v-else
                  :class="!isExternalCollaborator && !areActionsDisabled ? '':'disabled'"
                  class="associated-bom"
                  v-tooltip="bomAssociations[item.material_id].name"
                  @click="!areActionsDisabled && openAssociateBomModal(item, index)"
                >
                  {{ bomAssociations[item.material_id].name }}
                </div>
          </div>
          <div v-if="disableAction">
            <select v-model="item.priority" class="sort" @change="emitElementchange(index, $event.target.value)" :disabled="viewOnly || (item.status === 1 || item.status === 4)">
              <option  v-for="(element, index) in materialElement" :key="index" :value="element.id"> {{ element.name }}</option>
            </select>
          </div>
          <div >
            <img v-if="bomAssociations[item.material_id]" @click="openBomListData(item, index)" :class="{
            open: openBomDetails && selectedIndex === index,
            close: !(openBomDetails && selectedIndex === index),
          }" v-tooltip="'View BOM Details'" width="16" src="~@/assets/images/eye.svg" alt="" />
          </div>
            <!-- Show close button only when actions are allowed -->
            <div v-if="!areActionsDisabled" class="action" @click="removeMaterial(index)">
                <img
                  width="16px"
                  class="pt-1"
                  src="~@/assets/images/close.png"
                  alt=""
                />
                </div>
        </div>
        <div v-if="openBomDetails && selectedIndex === index" class="bom-child bom-details">
          <bom-detail-head :materialComponent="true" :headings="visibleHeadings"/>
          <bom-detail-body
            :showEdit="false"
            :materialComponent="true"
            :bomVersionId="bomAssociations[item.material_id]?.versionId"
            :bomId="bomAssociations[item.material_id]?.id"
          />
        </div>
      </div>
      </div>
    </div>
    <modal
      title="Select your materials"
      :open="open"
      @close="open = false"
      :closeOnOutsideClick="true"
    >
        <material-selector
        :selectedMaterials="componentValueTemp"
        :formTypeId="formTypeId"
        :clear="clear"
        @toggle-selected="toggleToSelected"
        @remove-selected="removeSelected"
        @add-materials="addSelectedMaterials"
        @cancel="handleCancel"
        @clear-tags="clearTags"
      />

    </modal>
        <modal
      :open="associateBom.show"
      @close="closeAssociateBomModal"
      title="Associate Bom"
    >
      <select-bom
        v-if="associateBom.show"
        :selectedBomId="associateBom.associated_bom_id"
        :product_code="associateBom.product_code"
        :selectedBomVersionId="associateBom.associated_bom_version_id"
        @selectBom="selectAssociateBom"
        @close="closeAssociateBomModal"
        :showCloseButton="true"
      />
    </modal>
  </div>
</template>

<script>
import {
  GetMaterialListByIdsQuery,
  GetMaterialElement
} from '@/api'
import SelectBom from '@/components/bom/common/selectBom.vue'
import modal from '../../common/modal.vue'
import LoadingCircle from '../../common/loadingCircle.vue'
import { mapGetters, mapMutations } from 'vuex'
import bomDetailBody from '../../../components/bom/common/bomDetailBody.vue'
import BomDetailHead from '../../../components/bom/common/bomDetailHead.vue'
import config from '@/config'
import MaterialSelector from '@/components/materialMaster/materialSelector.vue'

export default {
  components: {
    modal,
    MaterialSelector, // Register the new component
    LoadingCircle,
    SelectBom,
    bomDetailBody,
    BomDetailHead
  },
  name: 'MaterialComponent',
  props: {
    create: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'TEMPLATE'
    },
    data: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Array,
      default: () => []
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    formTypeId: {
      type: Number
    },
    formStatus: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      bomAssociations: {},
      selectedAssociatedBom: null,
      open: false,
      associateBom: {
        show: false,
        product_code: null,
        associated_bom_id: null,
        associated_bom_name: null,
        associated_bom_version: null,
        associated_bom_version_id: null,
        item: null,
        index: null
      },
      selectedMaterialsMap: {},
      loadingSelectedMaterials: false,
      componentValue: [],
      componentValueTemp: [],
      delete: [],
      insert: [],
      update: [],
      clear: false,
      openBomDetails: false,
      selectedIndex: null,
      materialElement: []
    }
  },
  computed: {
    ...mapGetters('tag', ['getTags'], ['selectedBomId']),
    ...mapGetters(['isExternalCollaborator']),
    ...mapGetters(['isOnProjectLevel']),
    addedBomItems () {
      return this.componentValue.map((item) => item.id)
    },
    visibleHeadings () {
      return [
        'Product Code',
        'Material ID',
        'UOM',
        'Description',
        'Unit Size',
        'Quantity',
        'Material Name'
      ]
    },
    isReadOnly () {
      return this.viewOnly || this.mode === 'VIEW'
    },
    areActionsDisabled () {
      return this.isReadOnly || (this.formTypeId === config.FORM_TEMPLATE_TYPE.JOF && this.mode === 'EDIT' && this.formStatus !== config.FORM_STATE_MAP.DRAFT)
    },
    disableAction () {
      return this.formTypeId === 5
    }
  },
  methods: {
    ...mapMutations('tag', ['clearAllTags']),

    // Keep all your existing methods...
    removeAttachedBom (index, materialId) {
      if (materialId) {
        this.$delete(this.bomAssociations, materialId)
        this.componentValue[index].bom_id = null
      }
    },

    tooltipFunc (item) {
      return item.workflow_template ? '' : 'No WF linked'
    },

    closeAssociateBomModal (bom) {
      this.associateBom.show = false
      this.associateBom.item = null
      this.associateBom.associated_bom_id = null
      this.associateBom.associated_bom_name = null
      this.associateBom.associated_bom_version = null
      this.associateBom.associated_bom_version_id = null
      this.associateBom.index = null
    },

    selectAssociateBom (bom) {
      const materialId = this.associateBom.material_id
      const isEmpty = Object.keys(bom).length === 0
      if (isEmpty) {
        this.removeAttachedBom(this.associateBom.index, materialId)
      } else if (this.selectedAssociatedBom && bom.id === this.selectedAssociatedBom.id) {
      }
      if (materialId) {
        this.$set(this.bomAssociations, materialId, {
          id: bom.id || null,
          name: bom.name || '',
          versionId: bom.versionId,
          productCode: bom.productCode
        })
      }
      this.selectedAssociatedBom = bom
      this.componentValue[this.associateBom.index].bom_id = this.bomAssociations[materialId].id || null
      const materialComponent = this.componentValue[this.associateBom.index]
      if (materialComponent.field_id) {
        this.update.push(materialComponent)
      } else {
        const insertedObj = this.insert.find((item) => item.material_id === materialComponent.material_id)
        if (insertedObj) {
          insertedObj.bom_id = materialComponent.bom_id
        }
      }
      this.emitChanges()
    },

    openAssociateBomModal (item, index) {
      const productCode = this.selectedMaterialsMap[item.material_id]?.product_code
      this.associateBom.show = true
      this.associateBom.item = item
      this.associateBom.product_code = productCode
      this.associateBom.associated_bom_id = item?.core_bom?.id
      this.associateBom.associated_bom_name = item?.core_bom?.name
      this.associateBom.associated_bom_version = item?.core_bom?.bom_versions[0]?.version_no
      this.associateBom.associated_bom_version_id = item?.core_bom?.bom_versions[0]?.id
      this.associateBom.index = index
      this.associateBom.material_id = item.material_id
    },

    emitChanges () {
      const value = {}
      if (this.insert.length) {
        value.insert = this.insert
      }
      if (this.delete.length) {
        value.delete = this.delete
      }
      if (this.update.length) {
        value.update = this.update
      }
      this.$emit('customChange', {
        field_id: this.$props.data.field_id,
        value
      })
    },

    handleUnitCostChange (index) {
      const material = this.componentValue[index]
      if (material.field_id) {
        const updatedObj = this.update.find((item) => item.material_id === material.material_id)
        if (updatedObj) {
          updatedObj.unit_cost = material.unit_cost
        } else {
          this.update.push({
            material_id: material.material_id,
            unit_cost: material.unit_cost,
            quantity: material.quantity
          })
        }
      } else {
        const insertedObj = this.insert.find((item) => item.material_id === material.material_id)
        if (insertedObj) {
          insertedObj.unit_cost = material.unit_cost
        }
      }
      this.emitChanges()
    },

    handleQuantityChange (index) {
      const material = this.componentValue[index]
      if (material.field_id) {
        const updatedObj = this.update.find((item) => item.material_id === material.material_id)
        if (updatedObj) {
          updatedObj.quantity = material.quantity
        } else {
          this.update.push({
            material_id: material.material_id,
            unit_cost: material.unit_cost,
            quantity: material.quantity,
            priority: material.priority
          })
        }
      } else {
        const insertedObj = this.insert.find((item) => item.material_id === material.material_id)
        if (insertedObj) {
          insertedObj.quantity = material.quantity
        }
      }
      this.emitChanges()
    },

    removeMaterial (index) {
      const material = this.componentValue[index]
      if (material.field_id) {
        this.delete.push(material.material_id)
      }
      this.componentValue.splice(index, 1)
      this.insert = this.insert.filter(doc => doc.material_id !== material.material_id)
      this.emitChanges()
    },

    toggleToSelected (item) {
      const index = this.componentValueTemp.findIndex(
        (selectedItem) => selectedItem.material_id === item.id
      )
      if (index > -1) {
        this.componentValueTemp.splice(index, 1)
      } else {
        this.componentValueTemp.push({
          material_id: item.id,
          quantity: 0,
          unit_cost: 0
        })
      }
    },

    openMaterialModal () {
      this.open = true
      this.componentValueTemp = JSON.parse(JSON.stringify(this.componentValue))
    },

    addSelectedMaterials () {
      this.clear = true
      this.clearAllTags()
      const newMaterials = this.componentValueTemp.filter(tempItem =>
        !this.componentValue.some(existingItem =>
          existingItem.material_id === tempItem.material_id
        )
      )
      for (const item of newMaterials) {
        item.unit_cost = 1
        if (this.formTypeId === 5) {
          item.priority = this.materialElement?.[2]?.id
        }
        if (!item.field_id) {
          item.quantity = 1
          this.insert.push(item)
        }
      }
      this.emitChanges()
      this.componentValue = [...this.componentValue, ...newMaterials]
      this.loadSelectedMaterialMap()
      this.open = false
      this.componentValueTemp = []
    },

    removeSelected (item) {
      const index = this.componentValueTemp.findIndex(
        (selectedItem) => {
          if (selectedItem.field_id) {
            this.delete.push(selectedItem.material_id)
          }
          return selectedItem.material_id === item.id
        }
      )
      this.emitChanges()
      if (index !== -1) {
        this.componentValueTemp.splice(index, 1)
      }
    },

    handleCancel () {
      this.clear = true
      this.open = false
    },

    loadSelectedMaterialMap () {
      const self = this
      this.loadingSelectedMaterials = true
      const materialMap = {}
      const materialIds = this.componentValue.map((item) => item.material_id)
      GetMaterialListByIdsQuery(materialIds).then((res) => {
        res.core_material_master.forEach((item) => {
          materialMap[item.id] = item
        })
        self.selectedMaterialsMap = materialMap
        this.loadingSelectedMaterials = false
      })
    },

    clearTags () {
      this.clear = false
      this.clearAllTags()
    },

    keyPress (e) {
      if (!this.open) {
      } else if (e instanceof KeyboardEvent && e.code === 'Escape') {
        this.clear = true
        this.open = false
      } else if (e instanceof KeyboardEvent && e.code === 'Enter') {
        this.addSelectedMaterials()
        this.open = false
      }
    },

    openBomListData (bomItem, index) {
      if (this.selectedIndex === index) {
        this.openBomDetails = !this.openBomDetails
      } else {
        this.selectedIndex = index
        this.openBomDetails = true
      }
    },

    getBomUrl (productCode, bomId, versionId) {
      if (this.isOnProjectLevel) {
        return `/bom/project/bom/${bomId}?bomVersionId=${versionId}`
      } else {
        return `/bom/product/${productCode}/bom/${bomId}?bomVersionId=${versionId}`
      }
    },

    async getElementList () {
      await GetMaterialElement().then((res) => {
        this.materialElement = res.custom_list_values
      })
    },

    emitElementchange (index, selectedValue) {
      const material = this.componentValue[index]
      const priority = parseInt(selectedValue) || this.materialElement?.[2]?.id
      if (material.field_id) {
        const updatedObj = this.update.find((item) => item.material_id === material.material_id)
        if (updatedObj) {
          updatedObj.priority = priority
        } else {
          this.update.push({
            material_id: material.material_id,
            unit_cost: material.unit_cost,
            quantity: material.quantity,
            priority: priority
          })
        }
      } else {
        const insertedObj = this.insert.find((item) => item.material_id === material.material_id)
        if (insertedObj) {
          insertedObj.priority = priority
        }
      }
      this.emitChanges()
    }
  },
  created () {
    document.body.addEventListener('keydown', this.keyPress)
    this.getElementList()
    this.componentValue = this.value
    this.componentValue.forEach(item => {
      if (item.core_bom) {
        this.$set(this.bomAssociations, item.material_id, {
          id: item.core_bom.id,
          name: item.core_bom.name,
          versionId: item.core_bom.bom_versions[0]?.id,
          productCode: item.core_bom.product_code
        })
      }
    })
    this.selectedAssociatedBom = this.componentValue[0]?.core_bom ? JSON.parse(JSON.stringify(this.componentValue[0]?.core_bom)) : null
    this.loadSelectedMaterialMap()
  },
  destroyed () {
    document.body.removeEventListener('keydown', this.keyPress)
  }
}
</script>

<style lang="scss" scoped>
/* Keep only the styles not related to the extracted component */
.disabled {
  cursor: pointer;
  pointer-events: none;
}

.form-input {
  &-loading {
    width: 800px;
    min-height: 800px;
    max-height: 900px;
  }
  &--material {
    position: relative;
    display: inline-block;
    width: 100%;
    margin-top: 10px;
    border: 1px solid rgb(179, 179, 179);
    min-height: 60px;
    max-height: 200px;
    overflow-y: auto;
    border-radius: 4px;
    &__no-material {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: rgb(179, 179, 179);
    }
  }
}

.add-bom {
  opacity: 0.4;
  cursor: not-allowed;
  &.active {
    opacity: 1;
    cursor: pointer;
  }
}

.material-table {
  input {
    font-size: var(--text-s);
    padding: 5px;
    width: 50px;
    border: 1px solid var(--brand-color-1);
  }
  th,
  td {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.bom-details {
  width: 97%;
  margin-top: 10px;
  margin-left: 10px;
  border: 1px solid rgb(231 193 151);
  min-height: 60px;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 4px;
}

.sort {
  height: 2em;
  font-size: var(--text-s);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 4px 4px;
}
</style>
